import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import { Typography } from '@material-ui/core';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxMission from "../../../../store/actionreducers/mission"
import ReactTable from "react-table";
import classNames from 'classnames';
import dateUtil from "../../../../util/dateUtil";
import {UecareStatus} from "../../../../components";

const missionStatusLabel = {
    todo: ['todo','rematching'],
    finished: ['done'],
    processing: ['finding', 'matched', 'chatRoomReadied', 'accepted', 'addTime', 'demandChange', 'medicalGo', 'medicalArrived', 'reserved'],
    no_feedback:['suggested', 'finish'],
    cancelled: ['cancelled', 'refused', 'failed'],
};

class MissionList extends Component {
    state = {
        selectedContactsMenu: null,
        now: new Date()
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    componentDidMount() {
        this.timerID = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            now: new Date()
        });
    }

    getPastTime(create_at) {
        const {now} = this.state;
        const milliseconds = now - new Date(create_at);
        const timeStr = dateUtil.format({
            milliseconds,
            formatPattern: 'HH:mm:ss',
            timezone: 0
        });
        const day = Math.floor(milliseconds / 1000 / 60 / 60 / 24);
        const dayStr = (day > 0) ? day + '天 ' : '';
        return dayStr + timeStr;
    }

    render() {
        const { classes, missions, limit } = this.props

        if (!missions || missions.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何任務
                    </Typography>
                </div>
            );
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    sortable={false}
                    filterable={false}
                    showPagination={false}
                    defaultPageSize={limit}
                    pageSize={limit}
                    className={classNames(classes.root, "-striped -highlight")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: "cursor-pointer",
                            onClick: async () => {
                                if (rowInfo) {
                                    try {
                                        const missionId = rowInfo.original.id;
                                        window.open(`/apps/mission/${missionId}`, "_blank")
                                    } catch (e) {
                                        console.warn('you got an error = ', e);
                                    }
                                }
                            }
                        }
                    }}
                    data={missions}
                    columns={[
                        {
                            Header: "任務編號",
                            accessor: "no",
                            width: 130,
                        },
                        {
                            Header: "任務類型",
                            accessor: "type.name",
                            width: 200,
                        },
                        {
                            Header: "請求",
                            accessor: "requester.user",
                            className: "font-bold",
                            width: 80,
                            Cell: row => {
                                const user = row.value;
                                return (
                                    <div className="flex flex-1 flex-row items-center ">
                                        {user.name}
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "醫師姓名",
                            accessor: "provider.user",
                            className: "font-bold",
                            width: 80,
                            Cell: row => {

                                const user = row.value;
                                if (user) {

                                    return (
                                        <div className="flex flex-1 flex-row items-center ">
                                            {/*<UecareAvatar className="w-24 h-24 m-8" src={user.avatar? user.avatar.url: 'https://res.cloudinary.com/uecare/image/upload/v1531703417/DefaultImage/medicalHead_3x.png'}/>*/}
                                            {user.name}
                                        </div>
                                    );
                                } else return '';
                            },
                        },
                        {
                            Header: "醫師所屬醫院",
                            accessor: "provider",
                            className: "font-bold",
                            width: 200,
                            Cell: row => {
                                const {hospital, unvalidated_hospital_name} = row.value || {};
                                if (!!hospital) {
                                    return (
                                        <div className="flex flex-1 flex-row items-center ">
                                            {hospital.name}
                                        </div>
                                    );
                                } else return unvalidated_hospital_name || '';
                            },
                        },
                        {
                            Header: "科別",
                            accessor: "division",
                            className: "font-bold",
                            width: 150,
                            Cell: row => {
                                const {division} = row.row.provider || {};
                                if (!!division) {
                                    return (
                                        <div className="flex flex-1 flex-row items-center ">
                                            {division.name}
                                        </div>
                                    );
                                } else return '';
                            },
                        },
                        {
                            Header: "狀態",
                            accessor: "status",
                            Cell: row => (<UecareStatus name={row.value.name} label={row.value.label}/>),
                            className: "items-center justify-center",
                            width: 100,
                            maxWidth: 150,
                        },
                        {
                            Header: "預約日期",
                            accessor: "reservation_mission.date",
                            width: 100,
                            Cell: row => (row.value
                                ? dateUtil.format({date: row.value, formatPattern: 'YYYY-MM-DD'})
                                : ''
                            ),
                        },
                        {
                            Header: "預約時間",
                            accessor: "reservation_mission.start_time",
                            width: 100,
                            Cell: row => (row.value || ''),
                        },
                        {
                            Header: "諮詢開始時間",
                            accessor: "start_service_time",
                            width: 150,
                            maxWidth: 200,
                            Cell: row => (row.value ? dateUtil.format({date: row.value, formatPattern: 'YYYY-MM-DD HH:mm:ss'}) : ''),
                            className: "items-center justify-center",
                        },
                        {
                            Header: "已過時間",
                            accessor: "start_service_time_past",
                            Cell: (row) => ((missionStatusLabel.todo + missionStatusLabel.processing).indexOf(row.original.status.label) === -1 || !(row.value)) ? '' : this.getPastTime(row.value),
                            className: "items-center justify-center",
                            maxWidth: 100,
                        },
                        {
                            Header: '錄影存檔狀態',
                            accessor: 'consult_mission.videoChatRoom.composingStatus.label',
                            Cell: row => ({
                                pending: '尚在諮詢',
                                composing: '轉檔中',
                                composed: '已完成',
                                empty: '無錄影',
                                'recording-failed': '錄影失敗',
                                'composition-failed': '轉檔失敗',
                            }[row.value]),
                            width: 100,
                            maxWidth: 150,
                        }
                    ]}
                />
            </FuseAnimate>
        )
    }
}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        setMissionListPageNumber: ReduxMission.ActionCreator.setMissionListPageNumber,
        setMissionListPageSize: ReduxMission.ActionCreator.setMissionListPageSize,
    }, dispatch);
}

function mapStateToProps({ global: { searchText }, mission: { listPageNumber, listPageSize } }) {
    return { searchText, listPageNumber, listPageSize }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(MissionList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/MissionList.js